<template>
  <!-- 头部整体盒子 -->
  <div>
    <div id="header" class="container-fuild">

      <!-- 头部顶部 -->
      <!--<div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>-->
      <!-- 电脑导航 -->
      <div class="header-nav container hidden-xs">
        <!-- 导航logo -->
        <div class="header-nav-logo" @click="changeLang">
          <img src="@/assets/images/logo.png">
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="item.path == toPath ? 'active' : ''"
            @click="navClick(index, item.name)">
            <router-link :to="item.path">
              {{ $t(item.name) }}
              <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
          <li v-if="!isLogin"><router-link to="login">
              <div class="btn btn-style">{{ $t("login_register") }}</div>
            </router-link></li>
          <li v-if="isLogin"><el-dropdown style="height:80px;">
              <span class="el-dropdown-link">
                {{ userInfo.nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><div @click="open">{{ $t("personal_info") }}</div></el-dropdown-item>
<!--                <el-dropdown-item><div @click="openCustom">{{ $t("custom_data") }}</div></el-dropdown-item>-->
                <el-dropdown-item><div @click="loginOut">{{ $t("logout") }}</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
<!--            <li>-->
<!--              <el-dropdown style="height:80px;">-->
<!--                <span class="el-dropdown-link">-->
<!--                  {{$t("language")}}:{{ lang }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--                </span>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                  <el-dropdown-item><div @click="changeLang('zh')">中文</div></el-dropdown-item>-->
<!--                  <el-dropdown-item><div @click="changeLang('en')">English</div></el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
<!--            </li>-->
          <li>
            <span :class="{active: isZh}" @click="changeLang('zh')">中文 </span> <span style="opacity: 0.5">|</span> <span :class="{active: isEn}" @click="changeLang('en')"> EN</span>
          </li>
        </ul>
      </div>
      <!-- 手机导航 -->
      <div class="header-nav-m container-fuild visible-xs">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/images/logo.png" alt="logo">
        </div>
        <!-- 导航栏 -->
        <div class="header-nav-m-menu text-center">
          {{ menuName }}
          <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
            <span :class="menuClass"></span>
          </div>
          <!-- 导航内容 -->
          <ul id="menu" class="header-nav-m-wrapper collapse">
            <li v-for="(item, index) in navList" :key="index" :class="item.path == toPath ? 'active' : ''"
              @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
              <router-link :to="item.path">
                {{ item.name }}
                <i class="underline"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="height:110px;"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: "Header",
  data() {
    return {
      isZh: true,
      isEn: false,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "homepage",
          path: "/",
          children: []
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "智能小镇管理系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "大数据管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        // {
        //   name: "相关服务",
        //   path: "/service",
        //   children: []
        // },
        // {
        //   name: "新闻动态",
        //   path: "/newsinformation",
        //   children: []
        // },
        // {
        //   name: "document_center",
        //   path: "/document",
        //   children: []
        // },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
      toPath: "",
      username:""
    };
  },
  computed: {
    // username() {
    //   let nickName = localStorage.getItem('open-nickName')
    //   return nickName ? nickName : ''
    // },
      ...mapState({
        isLogin: state => state.login.isLogin,
        userInfo: state => state.login.userInfo,
      }),
      lang(){
        return this.$t("language")=='Language'?'English':'中文'
      }
  },
  mounted() {
    const item = localStorage.getItem('lang');
    if (item == undefined || item.indexOf("zh") > -1) {
      this.isZh = true
      this.isEn = false
    } else {
      this.isZh = false
      this.isEn = true
    }
  },

  methods: {
    changeLang(lang){
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      window.location.reload()
    },
    open() {
       this.$router.push('/usermsg')
    },
    openCustom() {
       this.$router.push('/CompanyInfo')
    },
    loginOut() {
      localStorage.removeItem('Open-Admin-Token')
      localStorage.removeItem('open-userId')
      localStorage.removeItem('open-nickName')
      localStorage.removeItem('open-username')
      localStorage.removeItem('open-password')
      localStorage.removeItem('open-userInfo')
      this.$store.state.login.isLogin = false
      this.$router.push('/login')
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem( 'navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon -menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  },
  watch: {
    '$route': {
      handler: function(to, from) {
        // 处理路由变化的逻辑
        this.toPath = to.path
        // 重新加载组件
        this.$forceUpdate();
      },
      immediate: true  // 初始化时立即执行一次
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  position: fixed;
  width: 100%;
  z-index: 1;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #4A98F8;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 159px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #4A98F8;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #4A98F8;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #4A98F8;
  text-decoration: none;
  border-bottom: 2px solid #4A98F8;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #4A98F8;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #4A98F8;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}

.btn-style {
  padding: 10px 36px;
  font-size: 16px;
  color: #fff;
  border-radius: var(--border-radius-full);
  font-weight: 600;
  outline: none;
  border: 2px solid var(--primary-color);
  background: var(--primary-color);
  transition: all 1.8s ease-in-out;
}
.active {
  /*background-color: red;*/
  font-weight: 500;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue